import { Component, inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalLineItemComponent } from 'src/app/components/inventory-modals/modal-line-item.component';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { environment } from 'src/environments/environment';
import { PurchaseOrderStatus, PurchaseOrderStatusLabel } from 'src/app/models/purchase-order-status.enum';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-edit-purchase-order',
  template: `
    <div class="d-flex mb-4 mt-4">
      <h2>Inventario</h2>
      <xng-breadcrumb ></xng-breadcrumb>
    </div>
    <div class="d-flex mb-4 mt-4">
      <div>
        <ul #subnav app-nav-inventory 
          [currentView]="currentView" 
          class="sidebar-zazz list-unstyled"
        ></ul>
      </div>
      <div class="flex-fill ms-3">
        <div class="list-group">          
          <div class="list-group-item">
            <div class="d-flex">
              <div class="me-3"><img [src]="purchaseOrder?.supplier?.avatar"></div>
              <div class="flex-fill">
                <div class="list-group">
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>#PO</p>
                      </div>
                      <div class="text-end">{{purchaseOrder?.po_number}}</div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>Proveedor</p>
                      </div>
                      <div class="text-end">{{purchaseOrder?.supplier?.name}}</div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>Descripción</p>
                      </div>
                      <div class="text-end">{{purchaseOrder?.notes}}</div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>Status</p>
                      </div>
                      <div class="text-end">{{purchaseOrder?.status}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>        
      </div>
      
      <div class="ms-3 flex-fill">
        <div class="list-group">
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">Productos</div>
              <div class="">{{purchaseOrder?.purchase_order_items?.length}}</div>
            </div>
          </div>  
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">Costo total</div>
              <div class="">{{purchaseOrder?.total_amount | currency }}</div>
            </div>
          </div>
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">Fecha de creación</div>
              <div class="">{{ purchaseOrder?.created_at | date: 'YYYY-MM-dd HH:mm'}}</div>
            </div>
          </div>
          <div class="list-group-item">
            <div class="d-flex mt-3" *ngIf="canChangeStatus()">
              <div class="flex-fill">
                <div class="btn-group w-100">
                  <button 
                    *ngIf="canSubmitForApproval()" 
                    class="btn btn-warning"
                    (click)="submitForApproval()">
                    <fa-icon [icon]="icons.faPaperPlane" class="me-2"></fa-icon>
                    Enviar a aprobación
                  </button>
                  <button 
                    *ngIf="canApprove()" 
                    class="btn btn-success"
                    (click)="approve()">
                    <fa-icon [icon]="icons.faCircleCheck" class="me-2"></fa-icon>
                    Aprobar
                  </button>
                  <button 
                    *ngIf="canFulfill()" 
                    class="btn btn-info"
                    (click)="fulfill()">
                    <fa-icon [icon]="icons.faTruck" class="me-2"></fa-icon>
                    Marcar como Entregado
                  </button>
                  <button 
                    *ngIf="canComplete()" 
                    class="btn btn-primary"
                    (click)="complete()">
                    <fa-icon [icon]="icons.faFlag" class="me-2"></fa-icon>
                    Completado
                  </button>
                  <button 
                    *ngIf="canCancel()" 
                    class="btn btn-danger"
                    (click)="cancel()">
                    <fa-icon [icon]="icons.faTimes" class="me-2"></fa-icon>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="flex-fill">
        <div class="list-group mt-3">
          <div class="list-group-item">
            <div class="flex-fill">
              <div class="text-end">
                <button class="btn btn-zazz-default" (click)="openModalLineItem()">Agregar productos</button>
              </div>
            </div>
          </div>
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">
                <table class="table table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" class="text-start bg-zazz text-light py-2">Producto</th>
                      <th scope="col" class="text-start bg-zazz text-light py-2">Descripción</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">SKU</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Cantidad</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Precio</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Precio total</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Creado</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Solictado por</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Aprobado por</th>
                      <th scope="col" class="text-center bg-zazz text-light py-2">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr app-tr-purchase-order-item
                      [purchaseOrderItem]="purchase_order_item"
                      [purchaseOrder]="purchaseOrder"
                      [profile]="profile"
                      [permissions]="permissions"
                      (itemDeleted)="loadPurchaseOrder(purchaseOrder!.id!)"
                      (editRequested)="openModalLineItem()"
                      *ngFor="let purchase_order_item of purchaseOrder?.purchase_order_items"
                    ></tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <app-modal-line-item 
      [purchase_order]="purchaseOrder"
      (updateDismiss)="loadPurchaseOrder(purchaseOrder!.id!)"
    ></app-modal-line-item>
  `,
  styleUrls: []
})
export class EditPurchaseOrderComponent {
  readonly PurchaseOrderStatus = PurchaseOrderStatus;
  purchaseOrder: PurchaseOrder | null = null;
  invURL: string = environment.INV_REST_WSPREFIX;
  currentView: string = 'purchaseOrders';
  profile: any;
  permissions: any;
  @ViewChild(ModalLineItemComponent, { static: true }) modalLineItemComponent !: ModalLineItemComponent;
  storageService = inject(StorageService);
  constructor(
    private invService: InventoryService,
    private activeRoute: ActivatedRoute,
    public icons: IconsService,
    private toastr: ToastrService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);;
    this.activeRoute.params.subscribe(params => {
      this.loadPurchaseOrder(params['id']);
    });
  }

  loadPurchaseOrder(id: number) {
    this.invService.getPurchaseOrderById(id).subscribe({
      next: (purchaseOrder: PurchaseOrder) => {
        this.purchaseOrder = purchaseOrder;
      },
      error: (err: any) => {}
    });
  }

  openModalLineItem() {
    // this.modalLineItemComponent.open();
    const modalTemplate: any | undefined = this.modalLineItemComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalLineItem']);
    }
  }

  getStatusLabel(): string {
    const status = (this.purchaseOrder?.status ?? PurchaseOrderStatus.DRAFT) as PurchaseOrderStatus;
    return PurchaseOrderStatusLabel[status];
  }

  getStatusBadgeClass(): string {
    const status = this.purchaseOrder?.status ?? PurchaseOrderStatus.DRAFT;
    const classes: Record<PurchaseOrderStatus, string> = {
      [PurchaseOrderStatus.DRAFT]: 'badge bg-secondary',
      [PurchaseOrderStatus.PENDING_APPROVAL]: 'badge bg-warning',
      [PurchaseOrderStatus.APPROVED]: 'badge bg-success',
      [PurchaseOrderStatus.FULFILLED]: 'badge bg-info',
      [PurchaseOrderStatus.COMPLETED]: 'badge bg-primary',
      [PurchaseOrderStatus.CANCELLED]: 'badge bg-danger'
    };
    return classes[status as PurchaseOrderStatus];
  }

  canChangeStatus(): boolean {
    
    return this.authService.hasPermission('can_change_purchase_order_status') && !this.isStatusFinal();
  }

  isStatusFinal(): boolean {
    const status = (this.purchaseOrder?.status ?? PurchaseOrderStatus.DRAFT) as PurchaseOrderStatus;
    return status === PurchaseOrderStatus.COMPLETED || 
           status === PurchaseOrderStatus.CANCELLED;
  }

  canSubmitForApproval(): boolean {
    return (this.purchaseOrder?.status as unknown as PurchaseOrderStatus) === PurchaseOrderStatus.DRAFT;
  }

  canApprove(): boolean {
    return (this.purchaseOrder?.status as unknown as PurchaseOrderStatus) === PurchaseOrderStatus.PENDING_APPROVAL && 
            this.authService.hasPermission('can_approve_purchase_order');
  }

  canFulfill(): boolean {
    console.log("purchaseOrder?.status ===> ", this.purchaseOrder?.status);
    return (this.purchaseOrder?.status as unknown as PurchaseOrderStatus) === PurchaseOrderStatus.APPROVED;
    //            this.authService.hasPermission('purchase_orders.fulfill');

  }

  canComplete(): boolean {
    return (this.purchaseOrder?.status as unknown as PurchaseOrderStatus) === PurchaseOrderStatus.FULFILLED;
    //            this.authService.hasPermission('purchase_orders.complete');

  }

  canCancel(): boolean {
    return (this.purchaseOrder?.status as unknown as PurchaseOrderStatus) !== PurchaseOrderStatus.COMPLETED && 
           (this.purchaseOrder?.status as unknown as PurchaseOrderStatus) !== PurchaseOrderStatus.CANCELLED;
           //            this.authService.hasPermission('purchase_orders.cancel');

  }

  submitForApproval() {
    this.updateStatus(PurchaseOrderStatus.PENDING_APPROVAL);
  }

  approve() {
    this.updateStatus(PurchaseOrderStatus.APPROVED);
  }

  fulfill() {
    this.updateStatus(PurchaseOrderStatus.FULFILLED);
  }

  complete() {
    this.updateStatus(PurchaseOrderStatus.COMPLETED);
  }

  cancel() {
    if (confirm('Are you sure you want to cancel this purchase order?')) {
      this.updateStatus(PurchaseOrderStatus.CANCELLED);
    }
  }

  private updateStatus(newStatus: PurchaseOrderStatus) {
    if (!this.purchaseOrder?.id) return;

    this.invService.updatePurchaseOrderStatus(this.purchaseOrder.id, newStatus).subscribe({
      next: (response: any) => {
        this.toastr.success('Purchase order status updated successfully');
        this.loadPurchaseOrder(this.purchaseOrder!.id!);
      },
      error: (error) => {
        this.toastr.error('Error updating purchase order status');
      }
    });
  }


}
